<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-start">
    <div class="modal-title">Add To Combo</div>
  </div>
  <div class="modal-body" [formGroup]="form">
    <mdb-form-control class="form-fill">
      <mdb-select formControlName="campaignId" class="mdb-select" [filter]="true">
        <mdb-option *ngFor="let campaign of campaigns" [value]="campaign.id">{{
          campaign.name
        }}</mdb-option>
      </mdb-select>
      <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
      <mdb-error class="form-fill-error" *ngIf="form.controls.campaignId.hasError('required') && form.controls.campaignId.touched">Please provide Campaign</mdb-error>
    </mdb-form-control>
    <div class="divider"></div>
    <ng-container *ngIf="form.controls.campaignId.value">
      <mdb-form-control class="form-fill">
        <mdb-select formControlName="optionId" class="mdb-select" [filter]="true">
          <mdb-option *ngFor="let option of options" [value]="option.id">{{
            option.name
          }}</mdb-option>
        </mdb-select>
        <label mdbLabel class="form-label form-label--paybee">Select Preset Option</label>
        <mdb-error class="form-fill-error" *ngIf="form.controls.optionId.hasError('required') && form.controls.optionId.touched">Please provide Preset Option</mdb-error>
      </mdb-form-control>
    </ng-container>
    <mdb-form-control class="form-fill" >
      <app-mdbp-input mdbInput formControlName="count" maxLength="4" [isCurrencyMask]="true"  label='Count'>
          <input autocomplete="chrome-off" #inputNameC currencyMask formControlName="count" maxLength="4" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
          <mdb-error class="form-fill-error"  *ngIf="form.controls.count.hasError('required') && form.controls.count.touched">Please provide Count</mdb-error>
          <mdb-error class="form-fill-error"  *ngIf="form.controls.count.hasError('min') && form.controls.count.touched">Count cannot be less than 1</mdb-error>
      </app-mdbp-input>
    </mdb-form-control>
    <div class="row">
      <div class="d-flex align-items-center mat-slide-toggle__wrapper col-12">
          <app-mdb-switch label="Enforce Inventory" formControlName="enforceInventory"></app-mdb-switch>
      </div>
      <p class="help-content d-flex align-items-center mat-slide-toggle__wrapper col-12">If set and underlying option run out of available inventory, this option will be marked sold out</p>
  </div>
  </div>
  <div class="modal-footer modal-footer--ticket-combo">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--transparent btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn--paybee btn--black btn--md text-center w-100" (click)="confirm(dialog, form.value)">Confirm</button>
      </div>
    </div>
  </div>  
</ng-container>
